module.exports = __webpack_public_path__ + "static/LucasPope1-4615f0316b77b00ffdb803d0c5d11ac7.png";